import { ApiService } from 'services';

const getRedemptions = async (tokenId) =>
  await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/redemptions/me`,
  });

const getRedemptionOrders = async ({ redemptionId, ...queryParams }) =>
  await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/redemptions/${redemptionId}/orders/me`,
    queryParams,
  });

const getRedemptionOrder = async ({ redemptionId, orderId }) =>
  await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/redemptions/${redemptionId}/orders/${orderId}/me`,
  });

const getExchangeRates = async (redemptionId) =>
  await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/redemptions/${redemptionId}/exchange-rates/me`,
  });

const createRedemptionOrder = async ({
  redemptionId,
  tokenAmount,
  paymentCurrency,
  paymentInformation,
}) =>
  await ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/redemptions/${redemptionId}/orders/me`,
    body: {
      tokenAmount,
      paymentCurrency,
      paymentInformation: {
        iban: paymentInformation.iban,
        bicSwift: paymentInformation.bicSwift,
        bankName: paymentInformation.bankName,
        accountOwner: paymentInformation.accountOwner,
      },
    },
  });

const cancelRedemptionOrder = async ({ redemptionId, orderId }) => {
  await ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/redemptions/${redemptionId}/orders/${orderId}/cancel/me`,
  });
};

export default {
  getRedemptions,
  getExchangeRates,
  getRedemptionOrders,
  getRedemptionOrder,
  createRedemptionOrder,
  cancelRedemptionOrder,
};
